/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FEATURE_FLAG = "ALTERNATE_OLDEST_FIRST_VIEW" | "AVATARS" | "COMMENT_SEEN" | "CONFIGURE_PUBLIC_PROFILE_URL" | "COUNTS_V2" | "DATA_CACHE" | "DEFAULT_QA_STORY_MODE" | "DISABLE_LIVE_UPDATES" | "DISABLE_WARN_USER_OF_TOXIC_COMMENT" | "DISCUSSIONS" | "EMAIL_META" | "ENABLE_QA" | "ENABLE_RATINGS_AND_REVIEWS" | "EXTERNAL_MEDIA" | "NEW_COMMENT_COUNT" | "READ_MORE_NEW_TAB" | "REDUCED_SECURITY_MODE" | "RTE_SARCASM" | "SECTIONS" | "VIEWER_COUNT" | "Z_KEY" | "%future added value";
export type CommentContainer_settings = {
    readonly flattenReplies: boolean;
    readonly disableCommenting: {
        readonly enabled: boolean;
    };
    readonly topCommenter: {
        readonly enabled: boolean | null;
    } | null;
    readonly newCommenter: {
        readonly enabled: boolean | null;
    } | null;
    readonly featureFlags: ReadonlyArray<FEATURE_FLAG>;
    readonly " $fragmentRefs": FragmentRefs<"CaretContainer_settings" | "EditCommentFormContainer_settings" | "MediaSectionContainer_settings" | "ReactionButtonContainer_settings" | "ModerationRejectedTombstoneContainer_settings" | "ReplyCommentFormContainer_settings" | "ReportFlowContainer_settings" | "UsernameWithPopoverContainer_settings" | "UserTagsContainer_settings" | "ArchivedReportFlowContainer_settings" | "AuthorBadgesContainer_settings" | "ReportButton_settings">;
    readonly " $refType": "CommentContainer_settings";
};
export type CommentContainer_settings$data = CommentContainer_settings;
export type CommentContainer_settings$key = {
    readonly " $data"?: CommentContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_settings">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
        } as any)
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "CommentContainer_settings",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flattenReplies",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "DisableCommenting",
                "kind": "LinkedField",
                "name": "disableCommenting",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "TopCommenterConfiguration",
                "kind": "LinkedField",
                "name": "topCommenter",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "NewCommenterConfiguration",
                "kind": "LinkedField",
                "name": "newCommenter",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "featureFlags",
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CaretContainer_settings"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EditCommentFormContainer_settings"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MediaSectionContainer_settings"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReactionButtonContainer_settings"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ModerationRejectedTombstoneContainer_settings"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReplyCommentFormContainer_settings"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReportFlowContainer_settings"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UsernameWithPopoverContainer_settings"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserTagsContainer_settings"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ArchivedReportFlowContainer_settings"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AuthorBadgesContainer_settings"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReportButton_settings"
            }
        ],
        "type": "Settings",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '2e11e324bd37685961654744b738e722';
export default node;
